// Match the bulk-recipient separators used by the Datox approval workspace.
export function approvalRecipients(value: string, assigned: string[] = []) {
  const addresses = [...new Set(value.split(/[\s,;]+/).map((email) => email.trim().toLowerCase()).filter(Boolean))]
  const existing = new Set(assigned.map((email) => email.trim().toLowerCase()))
  const valid = (email: string) => email.length <= 254 && /^[a-z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]*[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)*$/i.test(email)
  return {
    emails: addresses.filter((email) => valid(email) && !existing.has(email)),
    invalid: addresses.filter((email) => !valid(email)),
    assigned: addresses.filter((email) => valid(email) && existing.has(email)),
  }
}
